import BaseStore from "@/store/baseStore";
import {getNewId} from "@/utils/id";
import {head, groupBy} from "lodash";

export const namespaced = true;

const baseURI = '/reinforcement_point/';

const baseStore = new BaseStore(baseURI);

const getDefaultState = () => ({
    ...structuredClone(baseStore.state)
});

export const state = getDefaultState();

export const mutations = {
    ...baseStore.mutations,
    DELETE_ITEMS(state, reinforcementId) {
        state.items = state.items.filter(item => item.properties.reinforcement !== reinforcementId)
        state.dirtyItems = state.dirtyItems.filter(item => item.properties.reinforcement !== reinforcementId)
    }
};

export const actions = {
    ...baseStore.actions,
    add({state, commit}, {selectedPoint, reinforcementId, points}) {
        const id = getNewId(state.items, 'id');
        let coordinates = [0, 0];
        if (selectedPoint) {
            coordinates = [...selectedPoint.geometry.coordinates];
        } else if (points.length > 0) {
            coordinates = [...head(points).geometry.coordinates];
        }
        const newItem = {
            id,
            geometry: {
                type: 'Point',
                coordinates
            },
            properties: {
                name: null,
                reinforcement: reinforcementId
            }
        };
        const index = state.items.findIndex(item => selectedPoint && selectedPoint.id === item.id) + 1;
        commit('ADD_ITEM_ON_INDEX', {item: newItem, index})
        commit('ADD_DIRTY_ITEM', newItem);
    },
    deleteByReinforcementId({commit}, reinforcementId) {
        commit('DELETE_ITEMS', reinforcementId)
    }
};

export const getters = {
    reinforcementPoints: (state) => (reinforcementId) => {
        return state.items.filter(item => item.properties.reinforcement === reinforcementId)
    },
    reinforcementPointNameChoices(state) {
        return state.options?.name.choices || [];
    },
    getPlotData(state, getters, rootState, rootGetters) {
        const reinforcementById = rootGetters['reinforcement/getReinforcementById'];
        const currentReinforcement = rootState['reinforcement'].currentItem;
        if (!Array.isArray(state.items)) {
            return [];
        }
        return Object.values(groupBy(state.items, 'properties.reinforcement'))
            .map(reinforcementPoints => {
                const orderedPoints = reinforcementPoints
                const reinforcementId = head(orderedPoints).properties.reinforcement;
                const reinforcement = reinforcementById(reinforcementId);
                let dash = 'solid';
                if (currentReinforcement && currentReinforcement.id !== reinforcementId) {
                    dash = 'dot';
                }

                return {
                    x: orderedPoints.map(point => point.geometry.coordinates[0]),
                    y: orderedPoints.map(point => point.geometry.coordinates[1]),
                    name: reinforcement?.name,
                    line: {
                        color: reinforcement?.color,
                        width: 3,
                        dash,
                        simplify: false,
                    },
                    marker: {
                        color: "rgb(255,255,255)",
                        size: 7,
                        line: {
                            color: "rgb(0,0,0)",
                            width: 1,
                        },
                    },
                    mode: "lines+text+markers",
                    type: "scatter",
                    textfont: {
                        family: "Roboto",
                    },
                };
            });
    }
};
